import { useContext, createContext } from "react"

type AppContextType = {
  widgetOpen: boolean;
  toggleWidget: () => void;
  messages: Array<{
    id: string;
    text: string;
    sender: "user" | "bot";
    timestamp: Date;
  }>;
  addMessage: (message: Omit<{ id: string; text: string; sender: "user" | "bot"; timestamp: Date; }, "id">) => void;
  isTyping: boolean;
  setIsTyping: (typing: boolean) => void;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);

export const useApp = () => {
  const context = useContext(AppContext)
  if (context === undefined) {
    throw new Error("useApp must be used within an AppProvider")
  }
  return context
}
